// Biomarker reducer actions
export type BiomarkerAction =
    | { type: 'SET_FIELDS'; fields: any[] }
    | { type: 'UPDATE_FIELD'; index: number; updates: any }
    | { type: 'UPDATE_FIELD_VALUE'; index: number; value: string }
    | { type: 'UPDATE_FIELD_REF_RANGE'; index: number; range: { min?: string | number; max?: string | number } }
    | { type: 'DELETE_FIELD'; index: number }
    | { type: 'RESET_FIELDS' }
    | { type: 'SET_CONFIRMED_ROWS'; confirmedRows: Set<string> }
    | { type: 'TOGGLE_ROW_CONFIRMATION'; indicatorId: string }
    | { type: 'CONFIRM_ALL_ROWS' };

// Biomarker reducer state
export interface BiomarkerState {
    fields: any[];
    confirmedRows: Set<string>;
}

// Initial biomarker state
export const initialBiomarkerState: BiomarkerState = {
    fields: [],
    confirmedRows: new Set<string>()
};

// Biomarker reducer
export const biomarkerReducer = (state: BiomarkerState, action: BiomarkerAction): BiomarkerState => {
    switch (action.type) {
        case 'SET_FIELDS':
            return {
                ...state,
                fields: [...action.fields]
            };
        case 'UPDATE_FIELD':
            const updatedFields = [...state.fields];
            updatedFields[action.index] = { ...updatedFields[action.index], ...action.updates };
            return {
                ...state,
                fields: updatedFields
            };
        case 'UPDATE_FIELD_VALUE':
            const valueUpdatedFields = [...state.fields];
            valueUpdatedFields[action.index] = { ...valueUpdatedFields[action.index], value: action.value };
            return {
                ...state,
                fields: valueUpdatedFields
            };
        case 'UPDATE_FIELD_REF_RANGE':
            const refRangeUpdatedFields = [...state.fields];
            const currentRange = refRangeUpdatedFields[action.index].labReferenceRange || {};
            refRangeUpdatedFields[action.index] = {
                ...refRangeUpdatedFields[action.index],
                labReferenceRange: {
                    ...currentRange,
                    ...action.range
                }
            };
            return {
                ...state,
                fields: refRangeUpdatedFields
            };
        case 'DELETE_FIELD':
            const filteredFields = state.fields.filter((_, i) => i !== action.index);
            const newConfirmedRows = new Set(state.confirmedRows);
            const deletedField = state.fields[action.index];
            if (deletedField) {
                newConfirmedRows.delete(deletedField.indicatorId);
            }
            return {
                ...state,
                fields: filteredFields,
                confirmedRows: newConfirmedRows
            };
        case 'RESET_FIELDS':
            return {
                ...state,
                fields: [],
                confirmedRows: new Set()
            };
        case 'SET_CONFIRMED_ROWS':
            return {
                ...state,
                confirmedRows: new Set(action.confirmedRows)
            };
        case 'TOGGLE_ROW_CONFIRMATION':
            const newConfirmed = new Set(state.confirmedRows);
            if (newConfirmed.has(action.indicatorId)) {
                newConfirmed.delete(action.indicatorId);
            } else {
                newConfirmed.add(action.indicatorId);
            }
            return {
                ...state,
                confirmedRows: newConfirmed
            };
        case 'CONFIRM_ALL_ROWS':
            const allConfirmed = new Set(state.fields.map(field => field.indicatorId));
            return {
                ...state,
                confirmedRows: allConfirmed
            };
        default:
            return state;
    }
};